import {BaseContainerModel} from '../../base-container.model';
import {bl_fi_mst_coupon_import_file_hdr_RowClass} from '../../../dbschema';

export class CouponImportFileHdrContainerModel extends BaseContainerModel {
  bl_fi_mst_coupon_import_file_hdr: bl_fi_mst_coupon_import_file_hdr_RowClass = new bl_fi_mst_coupon_import_file_hdr_RowClass();
}
